giftingPendingRefusalReason